import type { FaireProductEntity } from "../../entity_types/product";

export const p_d5g3fxrfs7: FaireProductEntity = {
  token: "p_d5g3fxrfs7",
  type: "product",
  name: "2 Inches Gemstone Angels | Pocket Angel | Crystal Angel",
  brandToken: "b_7ykttxenut",
  brandName: "Soothing Crystals",
  imageUrl:
    "https://cdn.faire.com/fastly/be4610ebb0f4fda2742e2818bea4e5f53c4cd63e7ead9ffa69b9ce45b471f834.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/da524506145cbe206fdc2f602b1f299c7b9e4788d4611c260f23a0e600bc42fe.png",
    "https://cdn.faire.com/fastly/c4fcbef0806c860d17169e21c8b2ad5cf9cc52844663d90e3e66e58b0290b9b7.png",
    "https://cdn.faire.com/fastly/39f0d7affadc293f9d36417d0041e92a02f8800e9bbcc6b38fa029060ac3ccd7.png",
    "https://cdn.faire.com/fastly/bf234b28726d5592deebb838fb27ffe408478bf6113f151fa543b98260233ac1.png",
    "https://cdn.faire.com/fastly/016e7bae1ad792d6d8d5c5b66929505b57f47f1125eb58824054c7218dbdddf5.png",
    "https://cdn.faire.com/fastly/ae34f084e813a0c44f79b8ec2de80d89b7712a9af3e739805bb90978fc9d3f18.png",
    "https://cdn.faire.com/fastly/b7966e32df3f35211427bc9353187d6e10c28b28693cdb8845eda7b8d45420e4.png",
    "https://cdn.faire.com/fastly/529ea329c776a59af990f17d28d2062b45a7fd21fe8a78aa82782f4520348483.png",
    "https://cdn.faire.com/fastly/6b814929c87b3513217220a52d59605685593f41e3b483d29e8deee7120df7af.png",
    "https://cdn.faire.com/fastly/93a2daeb7ba8bba7cc5bf24222de1c4c1844cbff7691f6986382ff1daedd828d.png",
    "https://cdn.faire.com/fastly/9c1975f9a103bd119c5bf8bba06d89a049beed5c5f3f826b687ee01efef1ae52.png",
    "https://cdn.faire.com/fastly/4656bcd0c3c72097371c61fa6e076119d7ba048a494bc81d8a7206f3fea5373e.png",
    "https://cdn.faire.com/fastly/fe0ca512f777d357ad44b9fc40f4f38b005beb0fc228ca60a63a85be19a42733.png",
    "https://cdn.faire.com/fastly/2f6a7deba90ce9a1e71e0bc719fe5b7ed45febc703eb3f2d0c0963db129071a4.png",
    "https://cdn.faire.com/fastly/d72be5de12fc9afb959c24084ecb5d8fae0ccd34ec7d87d1f0fc347ff26278a7.png",
    "https://cdn.faire.com/fastly/08a924c7d21a7e47d620f4e543fe3f74e20bfb1a198a42929044e0f30b1bbc97.jpeg",
    "https://cdn.faire.com/fastly/bc6862146274e92f986c9ca672139e398253e16e3be5b32f881953b48f9bc102.jpeg",
    "https://cdn.faire.com/fastly/098c0e5fca86d8dd4e953d66c83f5a58e272db720f4a8a5d4943e61f6694e860.jpeg",
    "https://cdn.faire.com/fastly/72ae675e5f1314c2fb6b7243fc4c9dfd7b6c297aa15d54d5bfa3ed634e88400d.jpeg",
    "https://cdn.faire.com/fastly/a95e24527fca437e2685298ccc8b94af7c1008543b693aa63b00975d8b1dd4f7.jpeg",
    "https://cdn.faire.com/fastly/53ab8497ee913164bf72368730592c9dddec2447220c48a96269791c684c4f41.jpeg",
    "https://cdn.faire.com/fastly/1ffa0318a46fddc070e969d58191aea2639558c5e3076bbeef695c0f6a777038.jpeg",
    "https://cdn.faire.com/fastly/b12c165fe5142adaee22f1be1d2267172b266d36480e80f03c9d3a8dd4572ddb.jpeg",
    "https://cdn.faire.com/fastly/840ef5adb4f30a5889898a216601d1f410af76927806881f9feae716f041c74f.jpeg",
    "https://cdn.faire.com/fastly/0eaa5b9e589bea606cc18ac48495559a07050e66ba764b79d7a3456a0c1de779.jpeg",
    "https://cdn.faire.com/fastly/4c6a41a92d98611203ae5b4f2b99f2861cae1e8aab8a061128662616a49021a9.jpeg",
  ],
  priceDollars: 6.1,
  description:
    "A beautiful hand-carved crystal angel crafted from 100% natural, ethically sourced crystal.\n\nGemstone Angels are calming crystal figures used in wellness, spiritual rituals, and smudging to clear negative energy, balance emotions, and enhance inner peace.\n\nOur angels are:\n  Crafted from high-quality crystal quartz\n  Size : 2 inches.\n\nSoothing Crystals has started a Journey in 2016, to offer high-quality, ethically-sourced crystals to collectors, artists, healers, and seekers from all walks of life.\n\nPeople consider it as: Gemstone angel figurines, pocket angel statues, healing crystal angels, guardian angel, angel aura gemstone.\n\nThis beautiful rose quartz pocket angel stone is perfect for healing, featuring a mini angel figurine & pocket-sized angels.",
  tags: [],
  msrpDollars: 12.19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:49.654Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
